import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import BotSweepLogo from "./BotSweepLogo";

const sectionLinks: Record<string, string> = {
  Features: "/#how-it-works",
  Pricing: "/#pricing",
  "How It Works": "/#how-it-works",
  FAQ: "/#faq",
  Contact: "mailto:support@botsweep.com",
  Privacy: "/privacy",
  Terms: "/terms",
  Security: "/security",
  GDPR: "/security#gdpr",
  About: "/about",
  Email: "mailto:support@botsweep.com",
  "What is Bot Detection?": "/blog/what-is-bot-detection",
  "Stop Scraping Bots": "/blog/stop-bots-scraping-website",
  "One Script Tag Setup": "/blog/bot-detection-script",
  "vs Cloudflare": "/alternatives/cloudflare-bot-management",
};

const Footer = React.forwardRef<HTMLElement>((_props, ref) => {
  return (
    <footer ref={ref} className="border-t border-border/30 py-16 px-6 bg-[hsl(225_50%_2%)]">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <BotSweepLogo size={20} />
              <span className="font-display font-bold text-sm text-foreground">
                BotSweep<span className="text-primary">.</span>
              </span>
            </div>
            <p className="text-[10px] text-foreground/60 font-mono leading-relaxed mt-3">
              Real-time bot intelligence
              <br />for modern websites.
            </p>
          </div>

          {[
            { title: "Product", links: ["Features", "Pricing", "How It Works", "FAQ"] },
            { title: "Resources", links: ["What is Bot Detection?", "Stop Scraping Bots", "One Script Tag Setup", "vs Cloudflare"] },
            { title: "Company", links: ["About", "Security", "Privacy", "Terms"] },
          ].map((col) => (
            <div key={col.title}>
              <p className="text-[9px] font-mono text-foreground/60 uppercase tracking-[0.2em] mb-4" aria-hidden="true">
                {col.title}
              </p>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    {sectionLinks[link]?.startsWith("http") || sectionLinks[link]?.startsWith("mailto") ? (
                      <a
                        href={sectionLinks[link]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[11px] text-foreground/60 font-mono hover:text-foreground transition-colors"
                      >
                        {link}
                      </a>
                    ) : (
                      <Link
                        to={sectionLinks[link] || "#"}
                        className="text-[11px] text-foreground/60 font-mono hover:text-foreground transition-colors"
                      >
                        {link}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-border/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[9px] text-foreground/50 font-mono">
            © 2026 BotSweep. All rights reserved.
          </p>
          <span className="inline-flex items-center gap-1 text-[9px] font-mono text-foreground/50">
            <ShieldCheck className="w-3 h-3" />
            SOC 2 In Progress
          </span>
          <p className="text-[9px] text-foreground/50 font-mono italic">
            Built to protect your revenue.
          </p>
        </div>
      </div>
    </footer>
  );
});

Footer.displayName = "Footer";

export default Footer;
